import { useState } from "react";
import { Link, useRouterState } from "@tanstack/react-router";
import { LayoutDashboard, Users, Stethoscope, CalendarDays } from "lucide-react";
import logoUrl from "@/assets/rafaelgonzalez_t.png";
import ChangePasswordsDialog from "@/components/ChangePasswordsDialog";

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";

const items = [
  { title: "Dashboard", url: "/dashboard", icon: LayoutDashboard },
  { title: "Pacientes", url: "/pacientes", icon: Users },
  { title: "Agenda", url: "/agenda", icon: CalendarDays },
  { title: "Profesionales", url: "/profesionales", icon: Stethoscope },
];


export function AppSidebar() {
  const { state } = useSidebar();
  const collapsed = state === "collapsed";
  const currentPath = useRouterState({ select: (s) => s.location.pathname });
  const [passwordsOpen, setPasswordsOpen] = useState(false);

  const isActive = (path: string) => (path === "/dashboard" ? currentPath === path : currentPath.startsWith(path));

  return (
    <Sidebar collapsible="icon" className="logo-texture-gray">
      <SidebarHeader className="h-14 flex-row items-center border-b py-0">
        <Link to="/dashboard" className="flex h-full w-full items-center gap-2 px-2">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-background">
            <img src={logoUrl} alt="Rafael González" className="h-full w-full object-contain" />
          </div>
          {!collapsed && (
            <div className="flex flex-col leading-tight">
              <span className="text-sm font-semibold">Rafael González</span>
              <span className="text-xs text-muted-foreground">Centro de Osteopatía</span>
            </div>
          )}
        </Link>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              {items.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild isActive={isActive(item.url)} tooltip={item.title}>
                    <Link to={item.url} className="flex items-center gap-3">
                      <item.icon className="h-4 w-4" />
                      {!collapsed && <span>{item.title}</span>}
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter className="border-t p-3 text-xs text-muted-foreground">
        {!collapsed && <span>v1.0 · Demo</span>}
      </SidebarFooter>
    </Sidebar>
  );
}







